"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Operation;
(function (Operation) {
    /// <summary>
    /// No op.
    /// </summary>
    Operation[Operation["Idle"] = 0] = "Idle";
    /// <summary>
    /// Making initial preparations, creating visual tree.
    /// </summary>
    Operation[Operation["Preparing"] = 1] = "Preparing";
    /// <summary>
    /// Pre-layout modifications of the visual tree.
    /// </summary>
    Operation[Operation["PreprocessVisualTree"] = 2] = "PreprocessVisualTree";
    /// <summary>
    /// Vertical layout in progress.
    /// </summary>
    Operation[Operation["VerticalLayout"] = 3] = "VerticalLayout";
    /// <summary>
    /// Horizontal layout in progress.
    /// </summary>
    Operation[Operation["HorizontalLayout"] = 4] = "HorizontalLayout";
    /// <summary>
    /// Creating and positioning connectors.
    /// </summary>
    Operation[Operation["ConnectorsLayout"] = 5] = "ConnectorsLayout";
    /// <summary>
    /// All layout operations have been completed.
    /// </summary>
    Operation[Operation["Completed"] = 6] = "Completed";
})(Operation || (Operation = {}));
exports.default = Operation;
